// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.container = {
    gap: 15,
};

orderConfirmationPageContainerStyles.orderInformationGridItem = {
    width: [12, 12, 12, 9, 9],
    printWidth: 12,
    css: css`
        order: 2;
    `,
};

orderConfirmationPageContainerStyles.orderTotalGridItem = {
    width: [12, 12, 12, 3, 3],
    css: css`
        order: 3;

        ${xScreen.lte("lg")} {
            &&& {
                margin-top: 50px;
            }
        }

        @media print {
            &&& {
                margin-top: 0;
                break-inside: avoid;
            }
            flex-basis: 100%;
            width: 100%;
            max-width: 100%;
        }
    `,
};

orderConfirmationPageContainerStyles.productListGridItem = {
    css: css`
        order: 4;
    `,
    width: 12,
};
